module.exports = __webpack_public_path__ + "media/images/fonts/lg-269f233c78c029ba7cceefa0dfa3e5af.ttf";